import { BooleanInput } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  tEntries,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { FormInputProps } from '../types'

export const BooleanFormInput: FunctionComponent<FormInputProps<boolean>> = ({
  'aria-labelledby': ariaLabelledBy,
  name,
  value,
  onChange,
}) => {
  const { t } = useWriskTranslation()

  return (
    <BooleanInput
      ariaLabelledBy={ariaLabelledBy}
      name={name}
      value={value}
      onSelect={onChange}
      trueLabel={t<string>([tEntries(name, 'yes'), tEntries('boolean.yes')])}
      falseLabel={t<string>([tEntries(name, 'no'), tEntries('boolean.no')])}
    />
  )
}
